import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2640d4f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu-user" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { computed } from "vue";
import { IonButton, IonImg, IonLabel, IonIcon } from "@ionic/vue";
import { useRouter } from "vue-router";
import { chevronForwardOutline } from "ionicons/icons";
import { useUserStore } from "@/store/user.store";
import defaultAvatar from "@/assets/images/avatar.png";


export default /*#__PURE__*/_defineComponent({
  __name: 'MenuProfileItem',
  emits: ["onClose"],
  setup(__props, { emit: __emit }) {

const router = useRouter();
const emit = __emit;
const userStore = useUserStore();
const user = computed(() => userStore.user);
const fullname = computed(() =>
  user.value?.firstName || user.value?.lastName
    ? `${user.value?.firstName || ""} ${user.value?.lastName || ""}`
    : ""
);

const gotoEditProfile = () => {
  emit("onClose");
  router.push("/edit-profile");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonImg), {
      class: "avatar-img",
      src: user.value?.profilePhoto || _unref(defaultAvatar)
    }, null, 8, ["src"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(IonLabel), { class: "fullname-text" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(fullname.value), 1)
        ]),
        _: 1
      }),
      _hoisted_2,
      _createVNode(_unref(IonButton), {
        class: "edit-profile-btn",
        shape: "round",
        onClick: gotoEditProfile
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Edit Profile "),
          _createVNode(_unref(IonIcon), { icon: _unref(chevronForwardOutline) }, null, 8, ["icon"])
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})